// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"styles_tabsContainer__3OJJE","tabs":"styles_tabs__3AvGb","createBtn":"styles_createBtn__JGeIN"};